import React from "react";
var __jsx = React.createElement;
import { faUserCircle } from "@fortawesome/pro-regular-svg-icons";
import classNames from "classnames";
import { t } from "i18next";
import { getFormattedDate } from "../../../../utils";
import AwesomeIcon from "../../../AwesomeIcon";
import { StatusBadge } from "./StatusBadge";
import { TaskLabel } from "./TaskLabel";
import { useWorkspacePermittedUsers } from "../../../WorkspaceManagement/services/useWorkspacePermittedUsers";
import { useMemo } from "react";
export function ReminderCard(_ref) {
  var id = _ref.id,
    created_by = _ref.created_by,
    resolved = _ref.resolved,
    title = _ref.title,
    remind_after = _ref.remind_after,
    labels = _ref.labels,
    linked_resources = _ref.linked_resources,
    owned_by = _ref.owned_by,
    owned_by_info = _ref.owned_by_info,
    workspaceId = _ref.workspaceId,
    onClick = _ref.onClick,
    isAira = _ref.isAira,
    activeReminderId = _ref.activeReminderId;
  var isActive = activeReminderId != null && activeReminderId === id;
  var reminderDate = getFormattedDate(remind_after, "PP");
  var owner_name = owned_by_info === null || owned_by_info === void 0 ? void 0 : owned_by_info.name;
  var _useWorkspacePermitte = useWorkspacePermittedUsers(!owner_name ? workspaceId : null),
    workspaceData = _useWorkspacePermitte.data;
  var userId = owned_by || null;
  var DEFAULT_LABEL_ARRAY = [{
    id: 0,
    name: "TASK",
    color: ""
  }];
  var resolvedLabels = labels !== null && labels !== void 0 && labels.length ? labels : DEFAULT_LABEL_ARRAY;
  var username = useMemo(function () {
    if (owner_name) return owner_name;
    if (!userId || !workspaceData || !workspaceData.users) {
      return created_by || "";
    }
    var user = workspaceData.users.find(function (u) {
      return u.id === userId;
    });
    return (user === null || user === void 0 ? void 0 : user.name) || created_by || "";
  }, [userId, workspaceData, created_by, owner_name]);
  var attachments = Object.values(linked_resources).reduce(function (res, curr) {
    return Array.isArray(curr) ? res + curr.length : res;
  }, 0);
  return /*#__PURE__*/React.createElement("div", {
    className: "rounded-xl overflow-hidden cursor-pointer ".concat(isActive ? "p-[2px] bg-teal-500 dark:bg-teal-400" : isAira ? "p-[1px] bg-[linear-gradient(to_right,#FF7869_0%,#E88482_31%,#C995A4_65%,#98AED9_100%)]" : "p-[1px] bg-gray-200 dark:bg-gray-700"),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-xl overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-5 p-5 bg-white dark:bg-[#202A35]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap min-w-0 flex-1"
  }, resolvedLabels === null || resolvedLabels === void 0 ? void 0 : resolvedLabels.map(function (label) {
    return /*#__PURE__*/React.createElement(TaskLabel, {
      key: label.id,
      label: label.name,
      isAira: isAira
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "shrink-0"
  }, /*#__PURE__*/React.createElement(StatusBadge, {
    resolved: resolved,
    remind_after: remind_after
  }))), /*#__PURE__*/React.createElement("p", {
    className: classNames("text-base text-gray-900 dark:text-gray-100 break-all", resolved && "line-through")
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between text-[12px] text-gray-500 dark:text-gray-400"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faUserCircle,
    size: "xs"
  }), /*#__PURE__*/React.createElement("span", null, username || "")), /*#__PURE__*/React.createElement("span", {
    className: "shrink-0"
  }, t("due_on"), " ", reminderDate))), attachments > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-5 py-4 dark:bg-gray-900 bg-gray-100 border-t border-gray-200 dark:border-gray-600 text-[12px] text-gray-500 dark:text-gray-400"
  }, t("label.records"), ": ", attachments, " ", t("files"))));
}